import { useQuery } from "@tanstack/react-query";
import { Search, ShieldCheck } from "lucide-react";
import { useState } from "react";
import { api } from "../api/client";
import { EmptyState, ErrorState, LoadingState } from "../components/AsyncState";
import { PageHeader } from "../components/PageHeader";
import { formatDateTime } from "../lib/format";

type Audit = {
  id: string;
  actor_type: string;
  actor_id: string | null;
  action: string;
  entity_type: string;
  entity_id: string;
  reason: string | null;
  occurred_at: string;
  request_id: string;
};
export function AuditPage() {
  const [search, setSearch] = useState("");
  const query = useQuery({
    queryKey: ["audit", search],
    queryFn: async () =>
      (await api<Audit[]>(`/audit?limit=100${search ? `&search=${encodeURIComponent(search)}` : ""}`)).data
  });
  return (
    <div className="page">
      <PageHeader title="سجل التدقيق" description="سجل غير قابل للتعديل للعمليات الحساسة والاستثناءات." />
      <section className="content-card filters-card">
        <label className="search-field">
          <span className="sr-only">بحث السجل</span>
          <Search aria-hidden="true" />
          <input
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="الإجراء أو نوع السجل أو معرّفه"
          />
        </label>
      </section>
      <section className="content-card">
        {query.isPending ? (
          <LoadingState />
        ) : query.isError ? (
          <ErrorState error={query.error} retry={() => query.refetch()} />
        ) : query.data.length === 0 ? (
          <EmptyState title="لا توجد أحداث" description="ستظهر العمليات الحساسة هنا فور تنفيذها." />
        ) : (
          <ol className="timeline">
            {query.data.map((item) => (
              <li key={item.id}>
                <div className="timeline-icon">
                  <ShieldCheck aria-hidden="true" />
                </div>
                <div>
                  <div className="row-between">
                    <strong>{item.action}</strong>
                    <time dateTime={item.occurred_at}>{formatDateTime(item.occurred_at)}</time>
                  </div>
                  <p>
                    {item.entity_type} · <span dir="ltr">{item.entity_id}</span>
                  </p>
                  {item.reason ? <small>السبب: {item.reason}</small> : null}
                  <small className="request-id">مرجع الطلب: {item.request_id}</small>
                </div>
              </li>
            ))}
          </ol>
        )}
      </section>
    </div>
  );
}
